(() => {
  const UNAVAILABLE_RE = /\b(sold out|unavailable|out of stock|source another)\b/i;
  const STATUS_RE = /\b(sold|sold out|unavailable|out of stock|source another)\b/i;
  let timer = null;

  const isUnavailable = (item) => {
    if (!item) return false;
    if (item.matches('[data-available="false"],[data-sold-out="true"],.sold-out,.is-sold-out')) return true;
    if (item.querySelector('[data-available="false"],[data-sold-out="true"],.sold-out,.is-sold-out,.price--sold-out')) return true;
    const explicit = [...item.querySelectorAll('.badge,.card__badge,.product__badge,.it-cut-card__status,.it-mineral-card__status,.product-status,.availability')]
      .map((node) => node.textContent || '')
      .join(' ');
    if (STATUS_RE.test(explicit)) return true;
    const text = (item.innerText || item.textContent || '').replace(/\s+/g, ' ').trim();
    return UNAVAILABLE_RE.test(text);
  };

  const sortGrid = (grid) => {
    if (!grid || grid.dataset.itStockSorting === '1') return;
    const children = [...grid.children].filter((node) => node.nodeType === 1);
    if (children.length < 2) return;

    const available = [];
    const unavailable = [];
    children.forEach((item) => (isUnavailable(item) ? unavailable : available).push(item));
    if (!unavailable.length || !available.length) return;

    const desired = available.concat(unavailable);
    const changed = desired.some((item, index) => children[index] !== item);
    if (!changed) return;

    grid.dataset.itStockSorting = '1';
    const fragment = document.createDocumentFragment();
    desired.forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
    delete grid.dataset.itStockSorting;
  };

  const placeModelNavigation = () => {
    const stage = document.querySelector('[data-it-model-nav-stage]');
    if (!stage) return;
    const nav = stage.querySelector('[data-it-watch-model-nav]');
    if (!nav) {
      stage.remove();
      return;
    }

    const target = document.querySelector('#ProductGridContainer');
    if (!target) return;

    /*
      Vertical collection layouts place the facets and ProductGridContainer in the
      same flex row. Inserting the model navigation beside ProductGridContainer
      compresses the catalogue into a narrow column. Move the navigation outside
      that row and place it before the sort/filter toolbar so it occupies the full
      collection width.
    */
    const verticalLayout = target.closest('.facets-vertical');
    if (verticalLayout && verticalLayout.parentNode) {
      const shell = verticalLayout.parentNode;
      const toolbar = [...shell.children].find((node) =>
        node !== verticalLayout && node.querySelector && node.querySelector('.wbsortbar')
      );
      shell.insertBefore(nav, toolbar || verticalLayout);
    } else if (target.parentNode) {
      target.parentNode.insertBefore(nav, target);
    }

    stage.remove();
  };

  const run = () => {
    placeModelNavigation();
    document.querySelectorAll('#product-grid,[data-it-cut-grid],[data-it-mineral-grid]').forEach(sortGrid);
  };

  const schedule = () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(run, 80);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }

  const root = document.body || document.documentElement;
  if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
})();
